
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 3c.624 0 1.248.213 1.781.594l1.656 1.156 1.875.25h.031c1.314.16 2.352 1.223 2.531 2.531.003.024.029.038.031.063h-.031l.375 1.875 1.156 1.656c.762 1.067.73 2.476.031 3.594v.031l-.031.031-1.156 1.656-.25 1.875 3.125 4.75 1.031 1.531h-4.781l-1.156 2.688L21.499 29l-1.031-1.563-3.156-4.75c-.818.379-1.779.349-2.625 0l-3.156 4.75L10.5 29l-.719-1.719-1.156-2.688H3.844l1.031-1.531 3.219-4.906-.313-1.719-1.188-1.656c-.762-1.067-.73-2.507-.031-3.625v-.031l.031-.031 1.156-1.5.25-1.938v-.031l.031-.031a3.385 3.385 0 012.563-2.563L10.624 5h.031l1.906-.25 1.656-1.156A3.084 3.084 0 0115.998 3zm0 2.031c-.229 0-.458.068-.625.188l-2 1.438-.25.031-2.094.281c-.015.003-.016.027-.031.031a1.398 1.398 0 00-1 1c-.004.015-.028.016-.031.031l-.281 2.094-.031.281-.156.188-1.25 1.625c-.301.482-.269 1.073-.031 1.406l1.281 1.781.156.188.031.25.406 2.281v.063a.978.978 0 00.125.375.877.877 0 00.688.438h.031l2.188.313.281.031.188.156 1.625 1.25c.482.302 1.073.269 1.406.031l1.781-1.281.188-.156.25-.031 2.281-.406h.063a.886.886 0 00.594-.313v-.031l.063-.031a.954.954 0 00.156-.438v-.031l.313-2.188.031-.25 1.406-1.969c.302-.482.269-1.042.031-1.375l-1.281-1.781-.156-.188-.031-.219-.406-2.219v-.063a.89.89 0 00-.813-.813h-.031l-2.188-.313-.25-.031-.219-.156-1.781-1.281a1.101 1.101 0 00-.625-.188zm6.906 15.219c-.409.323-.9.552-1.438.625-.024.003-.038.029-.063.031v-.031l-1.969.344-.469.344 2.125 3.25.688-1.594.25-.625h2.406zm-13.812.031l-1.531 2.313h2.406l.25.625.688 1.594 2.125-3.219-.438-.344-1.906-.25h-.031a2.88 2.88 0 01-1.563-.719z"}})])
          )
        }
      }
    